import api from 'data/api';

export const loadDimensions = api('GET /api/mobile/performance/dimensions');
